import ChatExplainer from 'components/chats/ChatExplainer';
import { Page, PageContent } from 'components/layout/page';
import PageTopBar from 'components/navigation/PageTopBar';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function MessagingHowto() {
  // Hooks
  const { t } = useTranslation();
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [queryStringParams, setQueryStringParams] = useSearchParams();
  const scrollableElement = useRef<HTMLDivElement>(null);

  function onBackButtonClick() {
    navigate(-1);
  }

  return (
    <Page>
      <PageTopBar title={t('chats.explainer.title')} backButton onBackButtonClicked={() => onBackButtonClick()} />
      <PageContent className="gap-0 px-2 pt-2" ref={scrollableElement}>
        <ChatExplainer scrollableElement={scrollableElement} disableNewConversationButton />
      </PageContent>
    </Page>
  );
}
